import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { HistoryQuestionnaireItem } from './questionnaire'

export const HISTORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_60_DAY_ER]: QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_ER_NOTES]: QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_60_DAY_HOSPITAL]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_HOSPITAL_NOTES]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_60_DAY_INJURIES]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_INJURY_NOTES]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_60_DAY_FALLS]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_FALL_NOTES]: QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_60_DAY_INFECTIONS]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_INFECTION_NOTES]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_60_DAY_MD]: QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_MD_NOTES]: QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY]:
    QuestionnaireAnswerType.STRING
}
